import { render, staticRenderFns } from "./PdfViewerModal.vue?vue&type=template&id=524a253e&"
import script from "./PdfViewerModal.vue?vue&type=script&lang=js&"
export * from "./PdfViewerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports